import { render, staticRenderFns } from "./selezionaDistributoriProdotti.vue?vue&type=template&id=56c2c3a6&"
import script from "./selezionaDistributoriProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./selezionaDistributoriProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports